import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.scss';
import WebShopClose from 'components/WebShopClose';
import DealershipSummary from '../DealershipSummary';

export const AllocationSummary = ({
  remaining,
  totalCartQuantity,
  submitted,
  allocationTitle,
}) => {
  return (
    <div className={styles.allocationSummary}>
      <div className={styles.allocationHeader}>
        <div className={styles.leftBanner}>
          <span className={styles.allocationTitle}>{allocationTitle}</span>
          <WebShopClose />
        </div>
      </div>
      <DealershipSummary />
    </div>
  );
};

AllocationSummary.propTypes = {
  allocationTitle: PropTypes.string.isRequired,
};

export default enhance(AllocationSummary);
